// extracted by css-extract-rspack-plugin
export default {"dotsWrapper":"_76d70713"};